/* eslint-disable import/prefer-default-export */
import configs from '../constants/configs';

/**
 * Initializes Pendo identifying the user
 * @param {object} user User information that will be used to identify a user in Pendo
 */
export const pendoInit = (user) => {
    if (configs.pendoEnabled && window.pendo) {
        window.pendo.initialize({
            visitor: {
                id: user.userID,
                email: user.email,
                department: user.department || 'N/A',
            },
            account: {
                id: user.accountID,
                is_paying: true,
                is_ic: true,
                plan: user.plan,
            },
        });
    }
};
